import { render, staticRenderFns } from "./QueueCountCard.vue?vue&type=template&id=045cb213&scoped=true&"
import script from "./QueueCountCard.vue?vue&type=script&lang=js&"
export * from "./QueueCountCard.vue?vue&type=script&lang=js&"
import style0 from "./QueueCountCard.vue?vue&type=style&index=0&id=045cb213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cb213",
  null
  
)

export default component.exports